import { THREEDS_REDIRECT_SEARCH_PARAM } from 'modules/payment/constants'

export const getRedirectUrl = (paymentPageId: string): string =>
  `${window.location.origin}/${paymentPageId}?${THREEDS_REDIRECT_SEARCH_PARAM}`
